import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AdminSidebar from 'components/admin/AdminSidebar';
import { useAdminSections } from 'components/admin/sections';
import BasePage from 'components/UI/BasePage';
import Page404 from 'pages/Page404';
import links from 'utils/links';

const AdminLayout = () => {
  const location = useLocation();
  const sections = useAdminSections();

  if (!sections.length) {
    return <Page404 />;
  }

  if (location.pathname === links.paths.admin) {
    return <Navigate replace to={sections[0].path} />;
  }

  return (
    <BasePage showAdminMenu>
      <AdminSidebar sections={sections} />
      <Outlet />
    </BasePage>
  );
};

export default AdminLayout;
